import type {PinnedRangeMappingHeuristicEntry} from './types'

export const BASE_HORIZONTAL_PADDING = 24
export const MAXIMAL_WIDTH = 390

export const CTX_ABSOLUTE_AVAILABLE_WIDTH = 'AVAILABLE_WIDTH'

export const CORNER_PINNED_RANGES: PinnedRangeMappingHeuristicEntry[] = [
    {min: 0, max: 70},
    {min: 71, max: 300, target: 70}
]
export const CENTER_COLUMN_PINNED_RANGES: PinnedRangeMappingHeuristicEntry[] = [
    {min: 0, max: 70},
    {min: 71, max: 300, target: 70}
]
export const CENTER_ROW_PINNED_RANGES: PinnedRangeMappingHeuristicEntry[] = [
    {min: 0, max: 70},
    {min: 71, max: 300, target: 70}
]

export const HEADER_COMPONENTS_WIDTH = {
    MENU_WIDTH: 30,
    COMPONENT_IN_HEADER_WIDTH: 40,
    HEADER_SIDE_MARGINS: 24,
    HEADER_COMPONENT_GAP: 12,
    LOGO_WIDTH: 120
}

export const INSIDE_MENU_COMPONENT_WIDTH = 160
